module.exports = __webpack_public_path__ + "static/media/recent-order-restaurant.50b54bab.svg";